import _extends from "@babel/runtime/helpers/extends";
import { useForkRef } from "@smartsheet/lodestar-utils";
import React, { forwardRef, useEffect } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { useOverflowTooltip } from "../../../util/useOverflowTooltip";
import { Tooltip, TooltipBody } from "../../tooltip";
import { ursaTypeRampDefinitions } from "../constants/ursaConstants";
import { TypeRampRoot } from "../styled/TypeRampV2Styles";
const elementIsScrollable = elem => {
  return !!elem && (elem.offsetHeight < elem.scrollHeight || elem.offsetWidth < elem.scrollWidth);
};
export const TypeRampV2 = /*#__PURE__*/forwardRef((props, parentRef) => {
  const {
    renderAs = "span",
    children,
    clientId,
    omitTooltip,
    tooltipPlacement = "auto",
    system,
    variant,
    ...rest
  } = props;
  const {
    key
  } = useTheme();
  const themeMode = key;
  const RootElement = renderAs;
  const {
    showOverflowTooltip,
    tooltipProps,
    targetProps,
    elementToMeasureRef
  } = useOverflowTooltip({
    tooltipTargetRef: parentRef,
    elementIsOverflowing: elementIsScrollable,
    isDisabled: omitTooltip,
    placement: tooltipPlacement
  });
  const combinedRef = useForkRef(elementToMeasureRef, targetProps.ref);
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      const isUrsaVariant = (variant in ursaTypeRampDefinitions);
      if (system === "lodestar" && isUrsaVariant) {
        console.warn(`The variant prop ${variant} doesn't apply to TypeRamp components 
                when the system='lodestar'. Please try passing system='ursa', or using a lodestar 
                compatible variant.`);
      }
    }
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React.createElement(TypeRampRoot, _extends({
    as: RootElement,
    "data-client-id": clientId,
    className: "sds-type-ramp-v2"
  }, rest, omitTooltip ? {} : targetProps, {
    ref: combinedRef,
    themeMode: themeMode,
    variant: variant,
    system: system
  }), children, showOverflowTooltip && !omitTooltip && /*#__PURE__*/React.createElement(Tooltip, tooltipProps, /*#__PURE__*/React.createElement(TooltipBody, null, children)));
});
TypeRampV2.displayName = "TypeRampV2";
//# sourceMappingURL=TypeRampV2.js.map